import { consoleEvents } from '@pb/utils'
import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'
import UspState from './types'

const fetchUspBannerStart = (state: UspState): UspState => ({
  ...state,
  isLoading: true,
})

const fetchUspBannerSuccess = (state: UspState, links): UspState => ({
  ...state,
  links,
  isLoading: false,
  isPopulated: true,
})

const fetchUspBannerFail = (state: UspState, error): UspState => {
  consoleEvents.error('Failed to fetch cart USP Banner', error)

  return {
    ...state,
    isLoading: false,
    isLoadingFailed: true,
  }
}

const reducer = createReducer<UspState>((on) => {
  on(actions.fetchUspBannerStart, fetchUspBannerStart)
  on(actions.fetchUspBannerSuccess, fetchUspBannerSuccess)
  on(actions.fetchUspBannerFail, fetchUspBannerFail)
}, initialState)

export default reducer
